import { EntityUnionType } from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getEntityNameLocoKeyByEntityType } from 'src/editor/shared/utils/get-entity-name-loco-key-by-entity-type'
import { EntityCustomNameInput } from './entity-custom-name-input'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { PageEntityInterface } from 'src/shared/types/base-entity-interface'

interface EntitySettingsNameProps {
  entity: OldEntityInterface | EntityUnionType | PageEntityInterface
}

export const EntitySettingsName = ({ entity }: EntitySettingsNameProps) => {
  const { t } = useTranslation()

  const isMasterBlock =
    'masterBlockId' in entity && Boolean(entity.masterBlockId)
  const isCustomNameEdited =
    entity.type === EntityTypeEnum.Form && 'customName' in entity

  return (
    <div className="mb-9 flex items-center gap-2">
      {isCustomNameEdited ? (
        <EntityCustomNameInput entity={entity as FormInterface} />
      ) : (
        <span className="text-heading-4">
          {t(getEntityNameLocoKeyByEntityType(entity.type))}
        </span>
      )}
      {isMasterBlock && (
        <i
          className="fa-light fa-bolt-lightning text-subheading-2"
          title={t('entity_settings.master_block_warning')}
        />
      )}
    </div>
  )
}
